import { motion } from "framer-motion";
import { Leaf, ChefHat, Users, Zap, Award, Heart } from "lucide-react";

const FEATURES = [
  { icon: Leaf, title: "Fresh Ingredients", desc: "Sourced daily — never frozen, never reheated." },
  { icon: ChefHat, title: "Authentic Recipes", desc: "Passed down through generations, untouched." },
  { icon: Users, title: "Family-Friendly", desc: "Warm space built for shared meals and stories." },
  { icon: Zap, title: "Fast Service", desc: "Hot food at your table in under fifteen minutes." },
  { icon: Award, title: "Quality First", desc: "Premium meats, organic spices, real ghee." },
  { icon: Heart, title: "Memorable Moments", desc: "We feed people the way we feed family." },
];

export const WhyChooseUs = () => {
  return (
    <section
      id="why"
      data-testid="why-choose-section"
      className="relative py-24 md:py-32 bg-brand-cream"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl mb-16"
        >
          <span className="font-heading uppercase text-[11px] tracking-[0.3em] font-bold text-brand-red">
            · Why Red Chilly's
          </span>
          <h2 className="mt-3 font-display uppercase text-5xl md:text-6xl lg:text-7xl leading-[0.9] text-brand-charcoal">
            Six reasons our<br />
            regulars <span className="text-brand-red italic">come back.</span>
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {FEATURES.map((f, i) => (
            <motion.div
              key={f.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.07, ease: [0.16, 1, 0.3, 1] }}
              whileHover={{ y: -6 }}
              className="group relative p-8 rounded-3xl bg-white border border-brand-border hover:border-brand-red/30 hover:shadow-[0_24px_60px_-20px_rgba(179,0,27,0.18)] transition-all"
              data-testid="why-feature-card"
            >
              <div className="w-14 h-14 rounded-2xl bg-brand-red/10 text-brand-red flex items-center justify-center mb-6 group-hover:bg-brand-red group-hover:text-brand-cream transition-colors duration-300">
                <f.icon size={26} strokeWidth={2} />
              </div>
              <h3 className="font-heading uppercase text-xl tracking-tight font-extrabold text-brand-charcoal">
                {f.title}
              </h3>
              <p className="mt-3 text-brand-charcoal/65 leading-relaxed">{f.desc}</p>
              <div className="absolute top-7 right-7 font-display text-2xl text-brand-red/15">
                0{i + 1}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
